import React, { useState, useEffect, useRef } from "react";
import "./Header.scss";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.webp";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const menuRef = useRef(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const navigateToSection = (section) => {
    navigate("/services");
    setTimeout(() => {
      document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    }, 200);
  };

  const toggleMenu = (event) => {
    event.stopPropagation();
    setMenuOpen((prev) => !prev);
  };

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };
  const handleOptionClick = () => {
    // Cerrar el dropdown después de hacer clic en una opción
    setDropdownOpen(false);
    // Cerrar el menú de hamburguesa en móviles
    setMenuOpen(false);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const navigateToContact = (contact) => {
    navigate("/contact");
    window.scroll(0, 0);
  };

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <div className="contentNav">
      <div className="section">
        <h3>
          More than drywall, more than paint, more than epoxy, a unique
          experience!
        </h3>
        {/* <div className="options">
          <button onClick={() => navigateToContact("contact")}>
            Areas de services
          </button>
          <button onClick={() => navigateToContact("contact")}>
            Own A Franchise Today!
          </button>
        </div> */}
      </div>
      <nav>
        <div className="contentLogo">
          <img src={logo} alt="logo" className="logo" />
        </div>
        <ul className={`list ${menuOpen ? "open" : ""}`} ref={menuRef}>
          <li>
            <Link to="/" onClick={handleNavClick}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/About" onClick={handleNavClick}>
              About
            </Link>
          </li>
          <li>
            <div
              className={`Dropdown ${dropdownOpen ? "open" : ""}`}
              ref={dropdownRef}
            >
              <div className="Dropbtn" id="Item" onClick={toggleDropdown}>
                Products <h4>&#9660;</h4>
              </div>
              <div className="Dropdown-content">
                <div className="dropItem">
                  <button
                    onClick={() => {
                      navigateToSection("CEF");
                      handleOptionClick();
                    }}
                  >
                    Epoxy floor
                  </button>
                </div>
                <div className="dropItem">
                  <button
                    onClick={() => {
                      navigateToSection("DW");
                      handleOptionClick();
                    }}
                  >
                    Drywall
                  </button>
                </div>
                <div className="dropItem">
                  <button
                    onClick={() => {
                      navigateToSection("Pix");
                      handleOptionClick();
                    }}
                  >
                    Paint
                  </button>
                </div>
              </div>
            </div>
          </li>

          <li>
            <Link to="/contact" onClick={handleNavClick}>
              Contact Us
            </Link>
          </li>
        </ul>

        <button
          className="menu"
          onClick={(event) => {
            event.stopPropagation();
            toggleMenu(event);
          }}
        >
          Menu
        </button>
      </nav>
    </div>
  );
};

export default Header;
